const getFirstReleaseYear = (releaseList) => {
  if (!releaseList || releaseList.length === 0) {
    return 'Unknown';
  }

  const firstRelease = releaseList.reduce((a, b) => {
    return new Date(a.start) < new Date(b.start) ? a : b;
  });

  return new Date(firstRelease.start).getFullYear();
};

export default getFirstReleaseYear;
